import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=2271c0ea&scoped=true&"
import script from "./personList.vue?vue&type=script&lang=js&"
export * from "./personList.vue?vue&type=script&lang=js&"
import style0 from "./personList.vue?vue&type=style&index=0&id=2271c0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271c0ea",
  null
  
)

export default component.exports